export class StepsWidthFactorData
{
    id:number;
    stepsWidthId:number;
    factorSetStepsId:number;
    value:number;
    timeTypeId:number;
}